export default class EnterpriseUpdateUserRequest {
  public firstName: string;
  public lastName: string;
  public email: string;

  constructor(options) {
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.email = options.email;
  }
}
